import React, { createContext, useCallback, useState } from 'react';
import { Modal, type ModalProps } from 'antd';
import { Icon } from '@brokerbay/elements-web';

export type BuyerAgreementContextType = {
  hasBuyerAgreed: boolean;
  setHasBuyerAgreed?: (val: boolean) => void;
  showBuyerAgreementModal?: (props: ModalProps) => void;
};

const BuyerAgreementContext = createContext<BuyerAgreementContextType>({
  hasBuyerAgreed: false,
});

export const BuyerAgreementContextProvider: React.FC = ({ children }) => {
  const [hasBuyerAgreed, setHasBuyerAgreed] = useState(false);

  const showBuyerAgreementModal = useCallback((props: ModalProps) => {
    Modal.warning({
      title: 'Written buyer agreement reminder',
      content:
        'A participant working with a buyer must enter into a written agreement with the buyer prior to the buyer touring any home.',
      okText: 'Yes, I understand',
      cancelText: 'Cancel',
      okCancel: true,
      centered: true,
      width: '450px',
      icon: <Icon icon="infoCircleOutlined" color="danger" size={20} />,
      ...props,
    });
  }, []);

  return (
    <BuyerAgreementContext.Provider
      value={{
        hasBuyerAgreed,
        setHasBuyerAgreed,
        showBuyerAgreementModal,
      }}
    >
      {children}
    </BuyerAgreementContext.Provider>
  );
};

export default BuyerAgreementContext;
